import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { VideoSection } from "@/components/VideoSection";
import { HowItWorks } from "@/components/HowItWorks";
import { InteractiveDemo } from "@/components/InteractiveDemo";
import { Testimonials } from "@/components/Testimonials";
import { UseCases } from "@/components/UseCases";
import { Features } from "@/components/Features";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { SEO, seoConfig } from "@/hooks/useSEO";

/**
 * Page d'accueil UNOTIF - Landing Page Marketing
 */

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO {...seoConfig.home} />
      <Header />
      <main>
        <Hero />
        <VideoSection />
        <HowItWorks />
        <InteractiveDemo />
        <Testimonials />
        <UseCases />
        <Features />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
